import { render, staticRenderFns } from "./TransactionData.vue?vue&type=template&id=9c20eda6&scoped=true&"
import script from "./TransactionData.vue?vue&type=script&lang=js&"
export * from "./TransactionData.vue?vue&type=script&lang=js&"
import style0 from "./TransactionData.vue?vue&type=style&index=0&id=9c20eda6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c20eda6",
  null
  
)

export default component.exports